import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

import Menu from "../../Components/Menu";

import Section1_Header from "../S1_Header";
import Section2_About from "../S2_About";
import S6_Tokenomics from "../S4_Tokenomics";
import S7_Roadmap from "../S5_Contact";
import Section9_Footer from "../S7_Footer";
import Swiper from "../../Components/Swipe";

import { PageWrapper } from "../../Styles/style";

import styled from "@emotion/styled";

const VideoBG = styled.img`
background-size: cover;
`
const Wrapper = styled.div`
// position: RELATIVE;
`
const MainPage = (props) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <>

      <PageWrapper 
      style={{overflow:"hidden"}}
      >
        <Menu/>
        <Section1_Header />
          <Section2_About />
          <Swiper/>
          <S6_Tokenomics />
          <S7_Roadmap />
          <Section9_Footer />
      </PageWrapper>
    </>
  );
};

export default MainPage;
